import EntityEditor from './EntityEditor.container'
export default EntityEditor
